//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headerSearch from  '../components/header-search'
import instance from '../assets/js/instance'
import { Toast } from 'vant'


export default {
  data () {
    return {
      min: true,
      id: '',
      baseUrl: process.env.BASE_URL,
      info: {
        brand_img: '',
        brand_name: '',
        company_img: ''
      },
      name: '',
      address: '',
      message: ''
    }
  },
  computed: {
    options () {
      return this.$t('contact')
    },
    path () {
      return this.$store.getters.getPath
    }
  },
  components: {
    headerSearch
  },
  methods: {
    getInfo () {
      instance.get('/api/brand/getBrandDetail?id=' + this.id).then(res => {
        let data = res.data
        if (data.code === 0) {
          this.info = data.data
        }
      }).catch(e => {
        console.log(e)
      })
    },

    submit () {
      this.showToast('提交中...')
      setTimeout(() => {
        this.showToast('提交成功...')
        this.name = ''
        this.address = ''
        this.message = ''
        this.clearToast()
      }, 2000)
    },


    showToast (data) {
      Toast.loading({
        duration: 0,
        mask: true,
        message: data || this.options.loading
      })
    },

    clearToast () {
      Toast.clear()
    },
  },
  mounted () {
    let id = ''
    if (this.$route.query.id) {
      id = this.$route.query.id
    }
    this.id = id
    this.getInfo()
  }
}
